import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  targetUser: {
    marginBottom: theme.spacing(2),
    padding: 0,
    backgroundColor: theme.palette.gray[0],
    boxShadow: 'none',
    border: `1px solid ${theme.palette.gray[1]}`,
    borderRadius: 4,
  },
  targetTitle: {
    fontWeight: 'bold',
    fontSize: 12,
    borderBottom: `1px solid ${theme.palette.gray[1]}`,
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  targetContainer: {
    padding: `${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(
      1,
    )}`,
  },
  targetFullName: {
    fontSize: 14,
  },
  targetUsername: {
    fontSize: 12,
    fontWeight: 'bold',
    fontFamily: 'Vazir',
  },
  targetId: {
    fontSize: 12,
  },
  profileImage: {
    width: 60,
    height: 60,
    borderRadius: 35,
    margin: 0,
    marginInlineEnd: theme.spacing(1),
  },
}));